/**
 * Is a CSS property supported in the current browser.
 * @param {string} prop
 * @param {string} value
 * @returns boolean
 */
function isCssPropertySupported(prop, value) {
  let d = document.createElement('div');
  d.style[prop] = value;
  return d.style[prop] === value;
}

/**
 * Global AJAX function to get the price list.
 * @param {string} categories for multiple categories separate them by a comma
 * @param {string} discount discount code
 * @param {boolean} include_private include private products
 * @param {{
 * start: () => void | undefined, success: () => void  | undefined,
 * error: () => void  | undefined, complete: () => void  | undefined }} callbacks
 * @returns void
 */
function getPriceList(categories, discount, include_private, callbacks) {
  const _start = Date.now();

  if (categories == null) {
    return handleError();
  }

  const data = {
    action: 'bb_get_pdf_product_list',
    categories,
    discount,
    include_private,
  };

  if (callbacks.start != null) {
    callbacks.start();
  }

  jQuery.ajax({
    url: bb_global_params.admin_ajax_url,
    data,
    timeout: 540000,
    dataType: 'binary',
    success: (blob, status, jqXHR) => {
      try {
        if (blob.size === 0) {
          throw new Error('Blob is empty');
        }

        const dispositionHeader = jqXHR.getResponseHeader(
          'Content-Disposition'
        );
        const filenameMatch =
          dispositionHeader == null
            ? null
            : dispositionHeader.match(/filename="?([^";]+)"?/);
        const filename = filenameMatch == null ? 'datei.pdf' : filenameMatch[1];

        if (callbacks.success != null) {
          callbacks.success(
            new Blob([blob], { type: 'application/pdf' }),
            filename
          );
        }
      } catch (error) {
        handleError(error);
      }
    },
    error: (error) => {
      handleError(error);
    },
    complete: () => {
      if (callbacks.complete != null) {
        callbacks.complete();
      }
      console.log(`All of it took: ${(Date.now() - _start) / 1000} seconds`);
    },
  });

  function handleError(error) {
    if (callbacks.error != null) {
      callbacks.error(error);
    }
  }
}

/**
 * Convert a base64 string to a PDF Blob.
 * @param {string} base64
 * @returns Blob
 */
function base64toBlob(base64) {
  var binary = atob(base64.replace(/\s/g, ''));
  var len = binary.length;
  var buffer = new ArrayBuffer(len);
  var view = new Uint8Array(buffer);
  for (var i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  return new Blob([view], { type: 'application/pdf' });
}
